// Modules
import { useCallback, useState } from 'react'
import axios from 'axios'

// Hooks
import useNotices from 'hooks/system/useNotices'

// Helpers
import { getAuthorizationHeader } from 'helpers/authentication'

// Constants
import { IS_LIVE, TWO_FACTOR_AUTHENTICATION_ENABLING_URL, TWO_FACTOR_AUTHENTICATION_QR_CODE_GENERATION_URL } from 'constants/environment'

// Hook: Authentication > Two-factor authentication
function useTwoFactorAuthentication () {
	// State
	const [isProcessing, setIsProcessing] = useState(false)

	// Data
	const { addNotice } = useNotices()

	// Functions (Memoized)
	const enable = useCallback(async code => {
		setIsProcessing(true)
		let hasError = false
			try {
				await axios({
					data: { token: code },
					headers: { ...getAuthorizationHeader() },
					method: 'POST',
					url: TWO_FACTOR_AUTHENTICATION_ENABLING_URL
				})
			} catch (error) {
				if (!IS_LIVE) console.error(error.response?.data?.message)
				hasError = true
				addNotice({ code: 'client.twoFactorAuthenticationEnablingError', type: 'error' })
			}
		setIsProcessing(false)
		return { hasError }
	}, [addNotice])
	const getQRCode = useCallback(async () => {
		let hasError = false
		try {
			const { data } = await axios({
				headers: { ...getAuthorizationHeader() },
				method: 'GET',
				url: TWO_FACTOR_AUTHENTICATION_QR_CODE_GENERATION_URL
			})
			if (!!data?.qrCode) return { data: data?.qrCode }
			else {
				hasError = true
				addNotice({ code: 'client.twoFactorAuthenticationQRCodeFetchingError', type: 'error' })
			}
		} catch (error) {
			if (!IS_LIVE) console.error(error.response?.data?.message)
			hasError = true
			addNotice({ code: 'client.twoFactorAuthenticationQRCodeFetchingError', type: 'error' })
		}
		return { hasError }
	}, [addNotice])
	/*
	const validate = useCallback(async code => {
		setIsProcessing(true)
			try {
				const response = await axios({
					data: { token: code },
					method: 'POST',
					url: TWO_FACTOR_AUTHENTICATION_VALIDATION_URL
				})
				console.log(response)
			} catch (error) {
				addNotice({ code: 'client.twoFactorAuthenticationValidationError', type: 'error' })
			}
		setIsProcessing(false)
	}, [addNotice])
	*/

	// Response
	return { enable, getQRCode, isProcessing/*, validate*/ }
}

// Export
export default useTwoFactorAuthentication
